<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="medium"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item
            :label="$l('table_label_fieldName') || '字段名称'"
            prop="fieldName"
          >
            <el-input
              clearable
              size="small"
              v-model="formData.fieldName"
              :placeholder="$l('form_label_pe_fieldName') || '请输入字段名称'"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('table_label_control_chinese_title') || '控件中文标题'"
            prop="controlLabelText"
          >
            <el-input
              clearable
              size="small"
              v-model="formData.controlLabelText"
              :placeholder="
                $l('form_label_pe_control_chinese_title') ||
                  '请输入控件中文标题'
              "
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('table_label_control_english_title') || '控件英文标题'"
            prop="controlLabelTextEn"
          >
            <el-input
              clearable
              size="small"
              v-model="formData.controlLabelTextEn"
              :placeholder="
                $l('form_label_pe_control_english_title') ||
                  '请输入控件英文标题'
              "
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item
            :label="$l('table_label_controlType') || '控件类型'"
            prop="controlType"
          >
            <dict-select
              size="small"
              clearable
              filterable
              v-model="formData.controlType"
              :body="controlTypeParams"
              :placeholder="$l('form_label_pe_controlType') || '请选择控件类型'"
              url="/sys/common/dict/system"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('table_label_sortOrder') || '字段顺序'"
            prop="sortOrder"
          >
            <el-input-number
              style="width:100%"
              clearable
              v-model="formData.sortOrder"
              :step="1"
              :precision="0"
              :min="0"
              :max="100"
              controls-position="right"
              :placeholder="$l('form_label_pe_field_order') || '请输入字段顺序'"
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('table_label_control_row') || '控件所在行'"
            prop="rowNo"
          >
            <el-input-number
              style="width:100%"
              clearable
              v-model="formData.rowNo"
              :step="1"
              :precision="0"
              :min="0"
              :max="100"
              controls-position="right"
              :placeholder="
                $l('form_label_pe_control_rowNo') || '请输入控件所在行'
              "
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('table_label_control_width') || '控件宽度'"
            prop="colSpan"
          >
            <el-input-number
              style="width:100%"
              clearable
              v-model="formData.colSpan"
              :step="1"
              :precision="0"
              :min="0"
              :max="24"
              controls-position="right"
              :placeholder="
                $l('form_label_pe_control_width') || '请输入控件宽度'
              "
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="$l('table_label_control_json') || '控件属性定义json'"
            prop="controlProps"
          >
            <el-input
              size="small"
              type="textarea"
              rows="4"
              v-model="formData.controlProps"
              clearable
              :placeholder="
                $l('form_label_pe_control_property_JSON') ||
                  '请输入控件属性定义json'
              "
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('table_label_isRequired') || '是否必输项'"
            prop="isRequired"
          >
            <el-row :gutter="20">
              <el-col :span="24">
                <el-radio-group v-model="formData.isRequired" size="small">
                  <el-radio label="Y">{{ $l('INDEX.YES') || '是' }}</el-radio>
                  <el-radio label="N">{{ $l('INDEX.NO') || '否' }}</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('INDEX.Status') || '状态'">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-radio-group
                  size="small"
                  v-model="formData.templateStatus"
                  :disabled="true"
                >
                  <el-radio label="Y">{{
                    $l('INDEX.form_label_valid') || '有效'
                  }}</el-radio>
                  <el-radio label="N">{{
                    $l('INDEX.form_label_invalid') || '无效'
                  }}</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
          v-if="disabled"
        >
          <el-form-item
            :label="$l('INDEX.creator') || '创建人'"
            prop="createByName"
          >
            <el-input
              clearable
              size="small"
              v-model="formData.createByName"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '不需要输入，由系统生成'
              "
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
          v-if="disabled"
        >
          <el-form-item
            :label="$l('INDEX.table_label_created_date') || '创建时间'"
            prop="createDate"
          >
            <el-input
              clearable
              size="small"
              v-model="formData.createDate"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '不需要输入，由系统生成'
              "
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
          v-if="disabled"
        >
          <el-form-item
            :label="$l('INDEX.table_label_modified_by') || '修改人'"
            prop="modifyByName"
          >
            <el-input
              clearable
              size="small"
              v-model="formData.modifyByName"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '不需要输入，由系统生成'
              "
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col
          :sm="{ span: 24 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
          v-if="disabled"
        >
          <el-form-item
            :label="$l('INDEX.table_label_modification_date') || '修改时间'"
            prop="modifyDate"
          >
            <el-input
              clearable
              size="small"
              v-model="formData.modifyDate"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '不需要输入，由系统生成'
              "
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    isadd: Boolean, //是否为添加功能
    materialTemplateCode: String,
    orgRow: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      regionShow: false,
      controlTypeParams: { dictType: 'controlType' },
      formData: { templateStatus: 'Y', isRequired: 'N' },
      rules: {
        fieldName: [
          {
            required: true,
            message: this.$l('form_label_pe_fieldName') || '请输入字段名称',
            trigger: 'change'
          }
        ],
        controlLabelText: [
          {
            required: true,
            message:
              this.$l('form_label_pe_control_chinese_title') ||
              '请输入控件中文标题',
            trigger: 'change'
          }
        ],
        controlLabelTextEn: [
          {
            required: true,
            message:
              this.$l('form_label_pe_control_english_title') ||
              '请输入控件英文标题',
            trigger: 'change'
          }
        ],
        controlType: [
          {
            required: true,
            message: this.$l('form_label_pe_controlType') || '请选择控件类型',
            trigger: 'blur'
          }
        ],
        sortOrder: [
          {
            required: true,
            message: this.$l('form_label_pe_field_order') || '请输入字段顺序',
            trigger: 'blur'
          }
        ],
        rowNo: [
          {
            required: true,
            message:
              this.$l('form_label_pe_control_rowNo') || '请输入控件所在行',
            trigger: 'blur'
          }
        ],
        colSpan: [
          {
            required: true,
            message: this.$l('form_label_pe_control_width') || '请输入控件宽度',
            trigger: 'blur'
          }
        ],
        controlProps: [
          {
            required: true,
            message:
              this.$l('form_label_pe_control_property_JSON') ||
              '请输入控件属性定义json',
            trigger: 'change'
          }
        ],
        isRequired: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'blur'
          }
        ],
        templateStatus: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.getData()
    this.regionShow = true
  },
  methods: {
    getData() {
      if (!this.materialTemplateCode) return
      this.$api
        .materialTemplateDetailApi({
          materialTemplateCode: this.materialTemplateCode
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      let params = { ...this.formData }
      if (!this.materialTemplateCode) {
        const { materialCategoryCode } = this.orgRow
        if (materialCategoryCode) {
          params = {
            ...this.formData,
            materialCategoryCode: materialCategoryCode,
            productLine: this.orgRow.productLine
          }
        }
      }
      this.loadingOpen()
      this.$api
        .materialTemplateSaveApi(params)
        .then(() => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success'
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存'
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    }
  }
}
</script>
